(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["axels-shopping-mode"] && !Shopify.designMode) return;
  try {
    (() => {
const dialog=document.getElementById('axels-mode-dialog');if(!dialog)return;
const config=window.axelsModeConfig,title=dialog.querySelector('#axels-mode-title'),switchNote=dialog.querySelector('[data-mode-switch-note]');
const defaultTitle=(dialog.querySelector('[data-mode-default-title-text]')?.textContent||'How are you getting your cookies?').trim();
const switchTitle=(dialog.querySelector('[data-mode-switch-title-text]')?.textContent||'Delivery or collection?').trim();
let chosen=false,modeOpener=null;try{chosen=!!localStorage.getItem('axels-shopping-mode');}catch(e){}
const current=()=>document.documentElement.dataset.axelsMode||'delivery';
const sync=()=>document.querySelectorAll('.axels-mode-toggle [data-mode],#axels-mode-dialog [data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mode===current())));
const openModeDialog=(switching,opener)=>{modeOpener=opener||document.activeElement;title.textContent=switching?switchTitle:defaultTitle;switchNote.hidden=!switching;sync();if(!dialog.open){dialog.showModal();requestAnimationFrame(()=>{const active=dialog.querySelector('[data-mode][aria-pressed="true"]')||dialog.querySelector('[data-mode]');active?.focus();});}};
if(!chosen)openModeDialog(false);else sync();
dialog.querySelector('[data-mode-close]').addEventListener('click',()=>dialog.close());
dialog.addEventListener('close',()=>{if(modeOpener&&document.contains(modeOpener))modeOpener.focus();modeOpener=null;});
document.addEventListener('click',async event=>{
 const openButton=event.target.closest('[data-mode-open]');if(openButton){event.preventDefault();openModeDialog(true,openButton);return;}
 const button=event.target.closest('[data-mode]');if(!button)return;
 const requested=button.dataset.mode,fromHeader=Boolean(button.closest('.axels-mode-toggle'));
 if(fromHeader&&!dialog.open){if(requested===current())return;event.preventDefault();openModeDialog(true,button);return;}
 if(requested===current()&&chosen){if(dialog.open)dialog.close();return;}
 const buttons=document.querySelectorAll('#axels-mode-dialog button,.axels-mode-toggle button,.axels-header__mode-status');buttons.forEach(b=>b.disabled=true);
 try{const previous=current();const cart=await window.axelsPrepareCart(requested);window.axelsTrack?.('mode_selected',{from_mode:previous,to_mode:requested,item_count:cart.item_count,total_pence:cart.total_price,currency:cart.currency||'GBP'});try{localStorage.setItem('axels-shopping-mode',requested);}catch(e){}document.documentElement.dataset.axelsMode=requested;sync();location.reload();}
 catch(error){alert(error.message||config.error);buttons.forEach(b=>b.disabled=false);}
});
})();
  } catch(e) { console.error(e); }
})();

})();
